<template>
  <div class="m-4">
    <filters
      v-model="filtersValue"
      @on-filter="changeFilter"
    ></filters>
    <div class="row">
      <div class="col-xl-6 col-12">
        <chart-line
          ref="chartLine"
          :columns="columns"
          :data="dataChart"
          :dataResponse="dataResponse"
          fieldTitle="employeeName"
          fieldX="employeeName"
          fieldY="totalParts"
          :labels="labels"
          :options="options"
        ></chart-line>
      </div>
      <div class="col-xl-6 col-12">
        <grid ref="grid" :config="gridConfig"/>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from '@/components/Chart/Utils'
import gridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { filterOrigin } from '@/utils/arrays'
import { api } from '@/services/api'

const utilsChart = new Utils()
export default {
  name: 'Reports',
  components: {
    'chart-line': () => import(/* webpackChunkName: 'Chart' */ '@/components/Chart/Bar'),
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'filters': () => import(/* webpackChunkName: 'QuickRFQ2' */ './Filters')
  },
  mounted () {
    return Promise.all([
      this.LoadDataChart(),
      this.loadDataGrid()
    ])
  },
  data () {
    return {
      gridConfig: gridConfig,
      filtersValue: {
        employeeID: null,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1
      },
      filters: [
        {
          field: 'employeeID'
        },
        {
          field: 'year',
          // eslint-disable-next-line
          template: 'yearMonth == ${data.data.year}${data.data.month < 10 ? "0" + data.data.month : data.data.month}'
        },
        // eslint-disable-next-line
        {
          field: 'month',
          template: ''
        }
      ],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            offset: true
          }]
        }
      },
      labels: utilsChart.getMonthLabels(),
      dataChart: [],
      columns: [
        {
          label: this.L10n('total-parts'), key: 'total-parts'
        },
        {
          label: this.L10n('total-suppliers'), key: 'total-suppliers'
        }
      ],
      dataResponse: []
    }
  },
  computed: {
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    queryOptionFilter () {
      let toolFilters = this.filters
        .filter(({ field }) => !!this.filtersValue[field])
        // eslint-disable-next-line
        .map(({ field, template = '${data.field}==${data.value}' }) => {
          return this.checkEs6AndRun(template, { field: field, value: this.filtersValue[field], data: this.filtersValue })
        })
        .filter((filterStr) => filterStr)
      toolFilters = toolFilters.length
        ? `${toolFilters.join(' && ')}`
        : ''
      return `${toolFilters}`
    }
  },
  methods: {
    changeFilter () {
      this.LoadDataChart()
      this.loadDataGrid()
    },
    getChart () {
      return waitValue(() => this.$refs.chartLine)
    },
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    loadDataGrid () {
      this.getGrid()
        .then(grid => {
          grid.model.store.get.filters = this.queryOptionFilter
          grid.loadData()
        })
    },
    /**
     * @desc Load data for chart
     * @returns {AxiosPromise<any>}
     */
    LoadDataChart () {
      const params = {
        'select': 'yearMonth.toString().Substring(0,4) as year, yearMonth.toString().Substring(4,2) as month,employeeID,employeeName,totalSuppliers,totalParts',
        'filter': this.queryOptionFilter
      }
      return api.get(`Statistics/GetAllStatisticsEmployeePerformanceRFQ2`, { params })
        .then((response) => {
          const dataSuppliers = response.data.value.map(({ employeeName, totalSuppliers }) => {
            return {
              x: employeeName,
              y: totalSuppliers,
              columnKey: 'total-suppliers'
            }
          })
          const dataParts = response.data.value.map(({ employeeName, totalParts }) => {
            return {
              x: employeeName,
              y: totalParts,
              columnKey: 'total-parts'
            }
          })
          this.labels = filterOrigin(response.data.value.map(({ employeeName }) => employeeName))
          this.dataChart = filterOrigin(dataSuppliers.concat(dataParts))
        })
        .then(() => {
          this.getChart()
            .then((chart) => {
              chart.render()
            })
        })
    }
  }
}
</script>
